import React from "react";
import {
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemText,
} from "@material-ui/core";

interface MobileMenuProps {
  open: boolean;
  onClose: () => void;
}

const MobileMenu: React.FC<MobileMenuProps> = ({
  open,
  onClose,
}) => {
  const items = [
    "Home",
    "Shop",
    "About",
    "Contact",
    "Vegetables",
    "Fruits",
    "Meat",
    "Canned Organic",
    "Organic",
    "Mushrooms",
    "Organic Food",
    "Fresh Onion",
    "Oatmeal",
    "Organic Juice",
  ];

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
    >
      <div className="mobile-drawer">
        <div className="mobile-logo">
          Organic<span>Shop</span>
        </div>

        <Divider />

        <List>
          {items.map((item) => (
            <ListItem
              button
              key={item}
              onClick={onClose}
            >
              <ListItemText primary={item} />
            </ListItem>
          ))}
        </List>
      </div>
    </Drawer>
  );
};

export default MobileMenu;